import React, { useEffect } from "react";

import { useAccessStatus } from "../../grace-period/hooks/useAccessStatus";
import { SPEC_FLAGS_MAP, SUBMISSION_SPEC_FLAGS_MAP } from "../../Common/constants/SpecFlagConstants";

import { ReactComponent as GraceLockIcon } from "../../../assets/images/common/GraceLock.svg";

import "./EventsFilter.css";

const FILTERS = [
  {
    display: "Scheduled",
    value: "scheduled",
    spec_flags: ["-2"],
    revealsResult: false,
  },
  {
    display: "Sampled",
    value: "sampled",
    spec_flags: ["-1"],
    revealsResult: false,
  },
  {
    display: "In Process",
    value: "in_process",
    spec_flags: ["0", "4"],
    revealsResult: false,
  },
  {
    display: "In Spec",
    value: "in_spec",
    spec_flags: ["1", "5"],
    revealsResult: true,
  },
  {
    display: "Out of Spec",
    value: "out_of_spec",
    spec_flags: ["2", "6"],
    revealsResult: true,
  },
];

const getFilterColor = (filter) => {
  if (filter.value === "scheduled") {
    return SUBMISSION_SPEC_FLAGS_MAP["-2"]?.color ?? "transparent";
  }

  if (filter.value === "sampled") {
    return "var(--color-text-specs-orange)";
  }

  const specValue = filter.spec_flags[0];
  return SPEC_FLAGS_MAP[specValue]?.color ?? "transparent";
};

export default function EventsFilter({
  specFilterValues,
  setSpecFilterValues,
}) {
  const { areResultsLocked } = useAccessStatus();

  useEffect(() => {
    if (!areResultsLocked) {
      return;
    }
    setSpecFilterValues((prev) => {
      const nextValues = prev.filter((value) => {
        const match = FILTERS.find((filter) => filter.value === value);
        return !match?.revealsResult;
      });
      return nextValues.length === prev.length ? prev : nextValues;
    });
  }, [areResultsLocked, setSpecFilterValues]);

  const toggleFilter = (filter) => {
    if (areResultsLocked && filter.revealsResult) {
      return;
    }
    setSpecFilterValues((prev) => (
      prev.includes(filter.value)
        ? prev.filter((value) => value !== filter.value)
        : [...prev, filter.value]
    ));
  };

  const clearFilter = (event, filter) => {
    event.stopPropagation();
    if (areResultsLocked && filter.revealsResult) {
      return;
    }
    setSpecFilterValues((prev) => prev.filter((value) => value !== filter.value));
  };

  return (
    <div className="EventsFilter__Container">
      <p className="EventsFilter__SectionLabel">STATUS</p>
      {FILTERS.map((filter) => {
        const isSelected = specFilterValues.includes(filter.value);
        const color = getFilterColor(filter);
        const isFilterLocked = areResultsLocked && filter.revealsResult;

        return (
          <button
            type="button"
            key={filter.display}
            className={`EventsFilter__Filter ${isSelected ? "EventsFilter__Filter--selected" : ""} ${isFilterLocked ? "EventsFilter__Filter--locked" : ""}`}
            style={{ "--status-color": color }}
            disabled={isFilterLocked}
            onClick={() => toggleFilter(filter)}
          >
            {isFilterLocked ? (
              <GraceLockIcon className="EventsFilter__LockIcon" aria-hidden />
            ) : (
              <span className="EventsFilter__ColoredBox" />
            )}
            <span className="EventsFilter__FilterText">{filter.display}</span>
            {isSelected && (
              <span
                className="EventsFilter__Cancel"
                onClick={(event) => clearFilter(event, filter)}
                aria-label={`Clear ${filter.display} filter`}
              >
                &times;
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
